// The world art (world.json, the floor sheets, people/*.json and *.webp, the plan) is served under fixed names with a
// stale-while-revalidate cache, and a person's frame table and sheet are fetched separately. Without a version in the
// URL a browser or the edge can pair a new frame table with an old sheet after an art change and draw slices of the
// wrong frames on the bench (seen on staging 2026-10-11). The build stamps a hash of public/world (vite.config.ts),
// so the URLs change exactly when the art does. Tests run unstamped and see the plain paths.
declare const __WORLD_V__: string | undefined;
const V = typeof __WORLD_V__ === 'string' ? __WORLD_V__ : '';

/** The URL of a file under /world/, versioned by the art it belongs to. */
export function worldUrl(path: string): string {
  return V ? `/world/${path}?v=${V}` : `/world/${path}`;
}
